var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2.5","d":"M13.81 26.25v-25M1.25 13.28h25"}));
}

Close.defaultProps = {"width":"27.5","height":"27.5","data-name":"Layer 1","viewBox":"0 0 27.5 27.5"};

module.exports = Close;

Close.default = Close;
